import { Page } from "@core/components/layout/page";
import {
  PageNavbar,
  PageNavbarItem,
} from "@core/components/layout/page-navbar";
import { createFileRoute, Outlet, useMatchRoute } from "@tanstack/react-router";
import { cn } from "web-design-system";

export const Route = createFileRoute("/(auth)/_headed/funds/_layout")({
  component: RouteComponent,
});

function RouteComponent() {
  const matchRoute = useMatchRoute();
  const isCompareRoute = Boolean(
    matchRoute({ to: "/funds/compare", fuzzy: true })
  );

  return (
    <Page className="flex flex-col bg-background rounded-lg size-full overflow-hidden">
      <Page.Content className={cn(isCompareRoute && "overflow-hidden")}>
        <PageNavbar className="sticky top-0 z-3 bg-background">
          <PageNavbarItem
            activeOptions={{ exact: true, includeSearch: false }}
            to="/funds"
          >
            Mutual Funds
          </PageNavbarItem>
          <PageNavbarItem
            to="/funds/compare"
            activeOptions={{ exact: true, includeSearch: false }}
            search={{ funds: ["F0GBR06RMJ", "F00000PZH1"] }}
          >
            Compare
          </PageNavbarItem>
          <PageNavbarItem to="/funds/nfo">NFOs</PageNavbarItem>
          <PageNavbarItem to="/funds/basket">Basket</PageNavbarItem>
        </PageNavbar>
        <Outlet />
      </Page.Content>
    </Page>
  );
}
